import { gql } from "apollo-boost";

const DesignFragment = gql`
    fragment Design on CreatorDesign {
        id
        title
        description
        imageSources {
            original
            largeCrop
            smallCrop
        }
    }
`;

const HitFragment = gql`
    fragment Hit on CreatorHit {
        userId
        displayName
        designerLevel
        reviewCount
        reviewRating
        expertiseCategories
        designs {
            ...Design
        }
        flags
        isAvailable
        isOnline
    }
    ${DesignFragment}
`;

const ResponseFragment = gql`
    fragment Response on CreatorsResponse {
        hits {
            ...Hit
        }
    }
    ${HitFragment}
`

export const GET_CREATORS = gql`
    query GetCreators($request: CreatorsRequest!) {
        creators(request: $request) {
            totalHits
            hits {
                ...Hit
            }
        }
    }
    ${HitFragment}
`;

export const GET_FEATURED_SEARCHES = gql`
    query GetFeaturedSearches(
        $logo: CreatorsRequest!
        $web: CreatorsRequest!
        $packaging: CreatorsRequest!
        $randomCategory: CreatorsRequest!,
        $keyword: CreatorsRequest!,
        $online: CreatorsRequest!
    ) {
        logo: creators(request: $logo) { ...Response }
        web: creators(request: $web) { ...Response }
        packaging: creators(request: $packaging) { ...Response }
        randomCategory: creators(request: $randomCategory) { ...Response }
        keyword: creators(request: $keyword) { ...Response }
        online: creators(request: $online) { ...Response }
    }
    ${ResponseFragment}
`;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/SearchQueries.ts